import { useState, useEffect } from "react"
import CustomSpinner from "../../../../components/spinners/CustomSpinner"

// ** Reactstrap Imports
import {
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem
} from "reactstrap"

// ** Third Party Components
import * as yup from "yup"
import Select from "react-select"
import { useFormik } from "formik"
import Flatpickr from "react-flatpickr"
import { Check, X, Trash} from "react-feather"

const ResponsabilidadCivilForm = (props) => {
  // ** State
  // const datosAsesoria = {

  const [open, setOpen] = useState('')

  const toggle = id => {
    open === id ? setOpen() : setOpen(id)
  }
  const [numeroProfesionistas, setnumeroProfesionistas] = useState(0)

  function datosAsesoria() {
    return {
      cliente: {},
      expedicion : false,
      datosEspecialidades        : {},
      datosGenerales: {
        nombreRazonSocial : '',
        domicilioCP : '',
        estado : '',
        municipio : '',
        correo : '',
        telefonoParticular : '',
        telefonoOficina : '',
        telefonoCelular : '',
        formaPago : '',
        vigenciaInicio : '',
        vigenciaFin : '',
        sumaAsegurada : '',
        denominacionTitulo : '',
        anioTitulo : '',
        cedulaTitulo : '',
        registroSSA : '',
        aniosPracticando : '',
        haTenidoContratos5Anios : false,
        companiaSeguros: '',
        companiaSuma: '',
        companiaVigencia: '',
        haCanceladoPorAlgunaAsegurada : false,
        motivos: ''
      },
      datosRelacionTrabajo: {
        nombreInstitucion     : '',
        ubicacionInstitucion  : '',
        descripcionPuestos    : '',
        requiereSupervicion   : false,
        especialidades        : {}
      },
      datosAparatos: {
        datosRayox : {},
        pacientesRadioactivasNaturales : false,
        pacientesRadioactivasNaturalesDetalles : '',
        pacientesRadioactivasArtificiales: false,
        pacientesRadioactivasArtificialesDetalles : '',
        pacientesRadioactivasOtros: false,
        pacientesRadioactivasOtrosDetalles : ''
      },
      datosOtrosRiesgos: {
        poseeFarmacias: false,
        numeroFarmaceuticosTituladosFarmaceuticos : '',
        numeroFarmaceuticosNoTituladosFarmaceuticos : '',
        poseeLaboratorios: false,
        numeroFarmaceuticosTituladosLaboratorios : '',
        numeroFarmaceuticosNoTituladosLaboratorios : ''
      },
      datosCobertura: {
        coberturas: {},
        coberturaBasica : false,
        profesionesVeterinarias : false,
        arrendatario : false,
        arrendatarioSublimite : '',
        asumida : false,
        primerosAuxiliosExtranjero : false,
        Estacionamiento : false,
        EstacionamientoSublimite : '',
        cuentaVigilancia : false,
        controlEntradasSalidas : false,
        otro : false,
        otroDetalle: '',
        inmuebles: [],
        experiencias: []
      }
    }
  }

  const catalogoFormaPago = [
    {
      label: 'Mensual',
      value: 'Mensual'
    },
    {
      label: 'Trimestral',
      value: 'Trimestral'
    },
    {
      label: 'Semestral',
      value: 'Semestral'
    },
    {
      label: 'Anual',
      value: 'Anual'
    }
  ]

  const especialidades = [
    {
      label : "Atención de Enfermedades Mentales",
      field :"atencionEnfermedadesMentales",
      detalles : null
    },
    {
      label : "Cirugía",
      field :"cirugia",
      detalles : null
    },
    {
      label : "Radiología",
      field :"radiologia",
      detalles : null
    },
    {
      label : "Ortopedia",
      field :"ortopedia",
      detalles : null
    },
    {
      label : "Ginecología",
      field :"ginecologia",
      detalles : null
    },
    {
      label : "Odontología",
      field :"odontologia",
      detalles : null
    },
    {
      label : "Urología",
      field :"urologia",
      detalles : null
    },
    {
      label : "Ortodoncia",
      field :"ortodoncia",
      detalles : null
    },
    {
      label : "Anestesiología",
      field :"anestesiologia",
      detalles : null
    },
    {
      label : "Oftalmología",
      field :"oftamologia",
      detalles : null
    }, 
    {
      label : "Otra  – Especificar",
      field :"otra",
      detalles : 'Especifique',
      fieldDetalles : 'otraDetalles'
    },
    { 
      classContoiner : ' col-12 ',
      label : "Cirugía Plástica o Estética con fines distintos a los anteriores – Especificar",
      field :"ciriguaDistintos",
      detalles : 'Especifique',
      fieldDetalles : 'ciriguaDistintosDetalles'
    },
    {
      classContoiner : ' col-12 ',
      label : "Cirugía Plástica o Estética con fines de Cirugía Reconstructiva Post-Traumática",
      field :"ciriguaReconstructiva",
      detalles : null
    },
    {
      classContoiner : ' col-12 ',
      label : "Cirugía Plástica o Estética con Cirugía Correctiva de Anormalidades Congénitas",
      field :"ciriguaCorrectiva",
      detalles : null
    }
  ]
  
  const rayos = [
    {
      label : "Aparatos de Rayos X con fines de diagnóstico",
      field :"aparatosRayosXDiagnostico"
    },
    {
      label : "Aparatos de Rayos X que ocasionalmente se utilicen para fines terapéuticos",
      field :"aparatosRayosXTerapeticos"
    },
    {
      label : "Aparatos Generadores de Rayos por aceleración de partículas",
      field :"aparatosGeneradoresRayosPorAceleracion"
    },
    {
      label : "Aparatos Generadores de Rayos de Onda Corta o de Rayos Corpusculares enriquecidos – Especificar",
      field :"AparatosGeneradoresRayosOnda",
      detalles : 'Especifique',
      fieldDetalles : 'AparatosGeneradoresRayosOndaDetalle'
      
    },  

    {
      label : "Aparatos Generadores de Rayo Láser",
      field :"aparatosGeneradoresRayosRayoLaser"
    },
    {
      label : "Otros - Especificar",
      field :"aparatosGeneradoresRayosOtros",
      detalles : 'Especifique',
      fieldDetalles : 'aparatosGeneradoresRayosOtrosDetalles'
      
    }
  ]

  const coberturas = [
    {
        label : "Cobertura Básica (Incisos 1.1 al 1.4)",
        field :"coberturaBasica"
    },
    {
        label : "Profesiones Veterinarias (Inciso 1.5)",
        field :"profesionesVeterinarias"
    },
    {
        label : "Arrendatario",
        field :"arrendatario",
        classContoiner: ' col-12 col-md-6',
        detalles : 'Sublímite anual',
        fieldDetalles : 'arrendatarioSublimite'
    },
    {
        label : "Asumida (anexar contratos)",
        field :"asumida"
    },
    {
        label : "Primeros Auxilios en el Extranjero",
        field :"primerosAuxiliosExtranjero"
    },
    {
        label : "Estacionamiento o garage de automóviles",
        field :"estacionamiento",
        classContoiner: ' col-12 col-md-6',
        detalles : 'Sublímite anual',
        fieldDetalles : 'estacionamientoSublimite'
    },
    {
        label : "Con Acomodadores",
        field :"cuantaConAcomodares"
    },
    {
        label : "Cuenta con vigilancia",
        field :"cuentaVigilancia"
    },
    {
        label : "Existe control de las entradas y salidas de autos",
        field :"controlEntradasSalidas"
    },
    {
        label : "Otra, especificar  ",
        field :"otro",
        classContoiner: ' col-12 col-md-6',
        detalles : 'Especifique',
        fieldDetalles : 'otroDetalle'
    }
  ]

  function extra(data) {
    especialidades.map((item) => {
      data.datosEspecialidades[item.field] = false
      if (typeof item.detalles == 'undefined' ? false : (item.detalles != null)) {
        data.datosEspecialidades[item.fieldDetalles] = ""
      }
    })
    rayos.map((item) => {
      data.datosCobertura.coberturas[item.field] = false
      if (typeof item.detalles == 'undefined' ? false : (item.detalles != null)) {
        data.datosAparatos.datosRayox[item.fieldDetalles] = ""
      }
    })
    coberturas.map((item) => {
      data.datosCobertura.coberturas[item.field] = false
      if (typeof item.detalles == 'undefined' ? false : (item.detalles != null)) {
        data.datosCobertura.coberturas[item.fieldDetalles] = ""
      }
    })
    return data
  }

  function initialValues() {
    if (props.accion === 1) {
      return extra(datosAsesoria())
    } else {
      return props.data
    }
  }

  function validationSchema() {
    return yup.object({})
  }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    onSubmit: (data, { resetForm }) => {
      
      data = {
        ...data,
        accion: props.accion,
        tipo: "empresarial",
        nombre: "Profesiones Médicas Seguro de Responsabilidad Civil",
        slug: "responsabilidad-civil-profesiones-medicas"
      }
      props.administrar(data, props.handleSuccess)
    }
  })
  
  function deleteItem (_item, tipo) {
    switch (tipo) {
      case 1: 
        formik.setFieldValue('datosCobertura.inmuebles', formik.values.datosCobertura.inmuebles.filter((item) => item !== _item))
        break
      case 2: 
        formik.setFieldValue('datosCobertura.experiencias', formik.values.datosCobertura.experiencias.filter((item) => item !== _item))
        break
    }
  }

  function addInmuebles() {
    const tmp = [...formik.values.datosCobertura.inmuebles].concat({
      tipo : '',
      ubicacion : '',
      uso : ''
    })
    formik.setFieldValue("datosCobertura.inmuebles", tmp)
  }

  function addExperiencias() {
    const tmp = [...formik.values.datosCobertura.experiencias].concat({
      danio : '', 
      causa : '',
      monto : ''
    })
    formik.setFieldValue("datosCobertura.experiencias", tmp)
  }
  
  return (
    <div>
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Profesiones Médicas Seguro de Responsabilidad Civil</h1>
      {/* Sección de datos generales */}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12 mb-2">Datos generales</h3>
        {/* nombreRazonSocial */}
        <div className="col-12 mb-1 w-input">
          <Label className="form-label fw-bolder" > Nombre completo o Razón social </Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.nombreRazonSocial}
            invalid={formik.errors.datosGenerales?.nombreRazonSocial && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['nombreRazonSocial']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.nombreRazonSocial && (<FormFeedback>{formik.errors.datosGenerales?.nombreRazonSocial}</FormFeedback>)}
        </div>
        {/* domicilioCP */}
        <div className="col-12 col-md-6 col-lg-8 mb-1 w-input">
          <Label className="form-label fw-bolder" >Domicilio</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.domicilioCP}
            invalid={formik.errors.datosGenerales?.domicilioCP && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['domicilioCP']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.domicilioCP && (<FormFeedback>{formik.errors.datosGenerales?.domicilioCP}</FormFeedback>)}
        </div>
        {/* correo */}
        <div className="col-12 col-md-6 col-lg-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >Correo electronico:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.correo}
            invalid={formik.errors.datosGenerales?.correo && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['correo']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.correo && (<FormFeedback>{formik.errors.datosGenerales?.correo}</FormFeedback>)}
        </div>
        {/* estado */}
        <div className="col-12 col-md-6 col-lg-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >Estado:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.estado}
            invalid={formik.errors.datosGenerales?.estado && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['estado']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.estado && (<FormFeedback>{formik.errors.datosGenerales?.estado}</FormFeedback>)}
        </div>
        {/* municipio */}
        <div className="col-12 col-md-6 col-lg-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >Municipio:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.municipio}
            invalid={formik.errors.datosGenerales?.municipio && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['municipio']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.municipio && (<FormFeedback>{formik.errors.datosGenerales?.municipio}</FormFeedback>)}
        </div>
        {/* ciudad */}
        <div className="col-12 col-md-6 col-lg-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >Ciudad:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.ciudad}
            invalid={formik.errors.datosGenerales?.ciudad && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['ciudad']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.ciudad && (<FormFeedback>{formik.errors.datosGenerales?.ciudad}</FormFeedback>)}
        </div>
        {/* telefonoParticular */}
        <div className="col-12 col-md-6 col-lg-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >Teléfono particular:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.telefonoParticular}
            invalid={formik.errors.datosGenerales?.telefonoParticular && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['telefonoParticular']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.telefonoParticular && (<FormFeedback>{formik.errors.datosGenerales?.telefonoParticular}</FormFeedback>)}
        </div>
        {/* telefonoOficina */}
        <div className="col-12 col-md-6 col-lg-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >Teléfono oficina:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.telefonoOficina}
            invalid={formik.errors.datosGenerales?.telefonoOficina && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['telefonoOficina']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.telefonoOficina && (<FormFeedback>{formik.errors.datosGenerales?.telefonoOficina}</FormFeedback>)}
        </div>
        {/* telefonoCelular */}
        <div className="col-12 col-md-6 col-lg-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >Teléfono celular:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.telefonoCelular}
            invalid={formik.errors.datosGenerales?.telefonoCelular && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['telefonoCelular']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.telefonoCelular && (<FormFeedback>{formik.errors.datosGenerales?.telefonoCelular}</FormFeedback>)}
        </div>
        {/* vigenciaInicio */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >Vigencia inicio:</Label>
          <Flatpickr
            id='vigenciaInicio'
            name='vigenciaInicio'
            value={formik.values.datosGenerales?.vigenciaInicio}
            className='form-control'
            options={{ dateFormat: 'Y-m-d' }}
            onChange={(_selectedDates, dateString) => { formik.setFieldValue("datosGenerales['vigenciaInicio']", dateString) }}
          />
          {formik.errors.datosGenerales?.vigenciaInicio && (<FormFeedback>{formik.errors.datosGenerales?.vigenciaInicio}</FormFeedback>)}
        </div>
        {/* vigenciaFin */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >Vigencia final:</Label>
          <Flatpickr
            id='vigenciaFin'
            name='vigenciaFin'
            value={formik.values.datosGenerales?.vigenciaFin}
            className='form-control'
            options={{ dateFormat: 'Y-m-d' }}
            onChange={(_selectedDates, dateString) => { formik.setFieldValue("datosGenerales['vigenciaFin']", dateString) }}
          />
          {formik.errors.datosGenerales?.vigenciaFin && (<FormFeedback>{formik.errors.datosGenerales?.vigenciaFin}</FormFeedback>)}
        </div>
        {/* formaPago */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >Forma de pago:</Label>
          <Select
            id="formaPago"
            className="react-select w-100"
            classNamePrefix="select"
            value={{
              label: formik.values.datosGenerales?.formaPago,
              value: formik.values.datosGenerales?.formaPago
            }}
            onChange={(e) => {
              formik.setFieldValue("datosGenerales['formaPago']",  e.value)
            }}
            options={catalogoFormaPago}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.datosGenerales?.formaPago && (<FormFeedback>{formik.errors.datosGenerales?.formaPago}</FormFeedback>)}
        </div>
        {/* sumaAsegurada */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >Suma asegurada:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.sumaAsegurada}
            invalid={formik.errors.datosGenerales?.sumaAsegurada && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['sumaAsegurada']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.sumaAsegurada && (<FormFeedback>{formik.errors.datosGenerales?.sumaAsegurada}</FormFeedback>)}
        </div>
        {/* denominacionTitulo */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >Denominación del Título Profesional:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.denominacionTitulo}
            invalid={formik.errors.datosGenerales?.denominacionTitulo && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['denominacionTitulo']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.denominacionTitulo && (<FormFeedback>{formik.errors.datosGenerales?.denominacionTitulo}</FormFeedback>)}
        </div>
        {/* anioTitulo */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >Año de otorgamiento del Título:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.anioTitulo}
            invalid={formik.errors.datosGenerales?.anioTitulo && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['anioTitulo']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.anioTitulo && (<FormFeedback>{formik.errors.datosGenerales?.anioTitulo}</FormFeedback>)}
        </div>
        {/* cedulaTitulo */}
        <div className="col-12 col-md-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >No. de Cédula en la Dirección General de Profesiones:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.cedulaTitulo}
            invalid={formik.errors.datosGenerales?.cedulaTitulo && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['cedulaTitulo']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.cedulaTitulo && (<FormFeedback>{formik.errors.datosGenerales?.cedulaTitulo}</FormFeedback>)}
        </div>
        {/* registroSSA */}
        <div className="col-12 col-md-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >No. de registro en la S.S.A:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.registroSSA}
            invalid={formik.errors.datosGenerales?.registroSSA && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['registroSSA']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.registroSSA && (<FormFeedback>{formik.errors.datosGenerales?.registroSSA}</FormFeedback>)}
        </div>
        {/* aniosPracticando */}
        <div className="col-12 col-md-4 mb-1 w-input">
          <Label className="form-label fw-bolder" >¿Cuántos años ha practicado de forma efectiva?:</Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.aniosPracticando}
            invalid={formik.errors.datosGenerales?.aniosPracticando && true}
            onChange={(e) => { formik.setFieldValue("datosGenerales['aniosPracticando']", e.target.value) }}
          />
          {formik.errors.datosGenerales?.aniosPracticando && (<FormFeedback>{formik.errors.datosGenerales?.aniosPracticando}</FormFeedback>)}
        </div>
        {/* haTenidoContratos5Anios */}
        <div className="col-12 d-flex flex-wrap  w-input" >
          <div className=" ww-auto mmr-1"><Label className='form-label fw-bolder my-auto' for={`input-haTenidoContratos5Anios`} >¿Ha tenido contratados en los últimos 5 años Seguros de Responsabilidad Civil Profesional?:</Label></div>
          <div className="ww-auto ">
              <div className='form-switch '>
                  <Input 
                  type='switch' 
                  name={`input-haTenidoContratos5Anios`} 
                  id={`input-haTenidoContratos5Anios`}
                  onChange={(e) => { formik.setFieldValue(`datosGenerales[haTenidoContratos5Anios]`, e.target.checked) }}
                  />
                  <Label className='form-check-label' for={`input-haTenidoContratos5Anios`}>
                  <span className='switch-icon-left'>
                      <Check size={14} />
                  </span>
                  <span className='switch-icon-right'>
                      <X size={14} />
                  </span>
                  </Label>
              </div>
          </div>
        </div>
        {  formik.values.datosGenerales.haTenidoContratos5Anios && (
          <div className="col-12 d-flex flex-wrap">
            {/* companiaSeguros */}
            <div className="col-12 mb-1 w-input">
              <Label className="form-label fw-bolder" >Compañía de seguros:</Label>
              <Input
                placeholder=""
                value={formik.values.datosGenerales.companiaSeguros}
                invalid={formik.errors.datosGenerales?.companiaSeguros && true}
                onChange={(e) => { formik.setFieldValue("datosGenerales['companiaSeguros']", e.target.value) }}
              />
              {formik.errors.datosGenerales?.companiaSeguros && (<FormFeedback>{formik.errors.datosGenerales?.companiaSeguros}</FormFeedback>)}
            </div>
            {/* companiaSuma */}
            <div className="col-12 col-md-6 mb-1 w-input">
              <Label className="form-label fw-bolder" >Suma Asegurada:</Label>
              <Input
                placeholder=""
                value={formik.values.datosGenerales.companiaSuma}
                invalid={formik.errors.datosGenerales?.companiaSuma && true}
                onChange={(e) => { formik.setFieldValue("datosGenerales['companiaSuma']", e.target.value) }}
              />
              {formik.errors.datosGenerales?.companiaSuma && (<FormFeedback>{formik.errors.datosGenerales?.companiaSuma}</FormFeedback>)}
            </div>
            {/* companiaVigencia */}
            <div className="col-12 col-md-6 mb-1 w-input">
              <Label className="form-label fw-bolder" >Vigencia:</Label>
              <Input
                placeholder=""
                value={formik.values.datosGenerales.companiaVigencia}
                invalid={formik.errors.datosGenerales?.companiaVigencia && true}
                onChange={(e) => { formik.setFieldValue("datosGenerales['companiaVigencia']", e.target.value) }}
              />
              {formik.errors.datosGenerales?.companiaVigencia && (<FormFeedback>{formik.errors.datosGenerales?.companiaVigencia}</FormFeedback>)}
            </div>
          </div>
        )}
        {/* haCanceladoPorAlgunaAsegurada  */}
        <div className="col-12 d-flex flex-wrap  w-input" >
          <div className=" ww-auto mmr-1"><Label className='form-label fw-bolder my-auto' for={`input-haCanceladoPorAlgunaAsegurada `} >¿Le ha sido rehusada o cancelada por alguna aseguradora la Póliza de Responsabilidad Civil Profesional?:</Label></div>
          <div className="ww-auto ">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`input-haCanceladoPorAlgunaAsegurada `} 
                checked={formik.values.datosGenerales.haCanceladoPorAlgunaAsegurada}
                id={`input-haCanceladoPorAlgunaAsegurada `}
                onChange={(e) => { formik.setFieldValue(`datosGenerales[haCanceladoPorAlgunaAsegurada]`, e.target.checked) }}
              />
              <Label className='form-check-label' for={`input-haCanceladoPorAlgunaAsegurada `}>
                <span className='switch-icon-left'> <Check size={14} /> </span>
                <span className='switch-icon-right'> <X size={14} /> </span>
              </Label>
            </div>
          </div>
        </div>
        {  formik.values.datosGenerales.haCanceladoPorAlgunaAsegurada  && (
          <div className="col-12 d-flex flex-wrap">
            {/* Motivos */}
            <div className="col-12 mb-1 w-input">
              <Label className="form-label fw-bolder" >Motivos:</Label>
              <Input
                placeholder=""
                value={formik.values.datosGenerales.motivos}
                invalid={formik.errors.datosGenerales?.motivos && true}
                onChange={(e) => { formik.setFieldValue("datosGenerales['motivos']", e.target.value) }}
              />
              {formik.errors.datosGenerales?.motivos && (<FormFeedback>{formik.errors.datosGenerales?.motivos}</FormFeedback>)}
            </div>
          </div>
        )}
      </div>
      {/* Sección de Especialidades */}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12 mb-2">Ejercicio Profesional por Cuenta Propia</h3>
        {/* especialidades */}
        <div className="col-12 w-input">
          <Label className="form-label fw-bolder" >Marque cuál(es) es(son) su(s) especialidad(es):</Label>
          {especialidades.length > 0 && (
              <div className="col-12 d-flex flex-wrap mb-2">
                {especialidades.map((_item, index) => (
                  // {formik.values.especialidades.length > 0 &&
                  //   formik.values.especialidades.map((_item, index) => (
                  <div key={ `input${index}`} className={ ` ${_item.classContoiner ? _item.classContoiner : (_item.detalles === null ? " col-12 col-md-6 "  : " col-12 ")} d-flex flex-wrap mb-1`}>
                    <div className={ ` col-12  d-flex flex-wrap `}>
                      <div className="ww-auto ">
                        <div className='form-switch '>
                            <Input 
                            type='switch' 
                            checked={formik.values.datosEspecialidades[_item.field]}
                            name={`input-${_item.field}`} 
                            id={`input-${_item.field}`}
                            // value={formik.values.datosEspecialidades[_item.field]}
                            onChange={(e) => { formik.setFieldValue(`datosEspecialidades["${_item.field}"]`, e.target.checked) }}
                            />
                            <Label className='form-check-label' for={`input-${_item.field}`}>
                            <span className='switch-icon-left'>
                                <Check size={14} />
                            </span>
                            <span className='switch-icon-right'>
                                <X size={14} />
                            </span>
                            </Label>
                        </div>
                      </div>
                      <div className=" ww-auto mmr-1">
                        <Label className='form-label fw-bolder my-auto' for={`input-${_item.field}`} >{_item.label}</Label>
                      </div>
                    </div>
                    {  ((typeof _item.detalles == '' ? false : _item.detalles !=  null)  && formik.values.datosEspecialidades[_item.field]) && (
                      <div className= {` col-12 justify-center w-input`}>
                        <Label className="form-label fw-bolder"  for={`input-${_item.fieldDetalles}`}>{_item.detalles} {_item.fieldDetalles}:</Label>
                        <Input
                          value={ formik.values.datosEspecialidades[_item.fieldDetalles] }
                          onChange={(e) => { formik.setFieldValue(`datosEspecialidades[${_item.fieldDetalles}]`, e.target.value) }}
                        />
                      </div>
                    )}
                    
                  </div>
                ))}
              </div>
          )}
        </div>
      </div>
      {/* Sección de datos Relación de Trabajo */}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12 mb-2">Ejercicio Profesional bajo Relación de Trabajo</h3>
        {/* nombreInstitucion */}
        <div className="col-12 mb-1 w-input">
          <Label className="form-label fw-bolder" > Nombre de la institución, establecimiento, empresa o médico para los que presta sus servicios </Label>
          <Input
            placeholder=""
            value={formik.values.datosRelacionTrabajo.nombreInstitucion}
            invalid={formik.errors.datosRelacionTrabajo?.nombreInstitucion && true}
            onChange={(e) => { formik.setFieldValue("datosRelacionTrabajo['nombreInstitucion']", e.target.value) }}
          />
          {formik.errors.datosRelacionTrabajo?.nombreInstitucion && (<FormFeedback>{formik.errors.datosRelacionTrabajo?.nombreInstitucion}</FormFeedback>)}
        </div>
        {/* ubicacionInstitucion */}
        <div className="col-12 mb-1 w-input">
          <Label className="form-label fw-bolder" >Ubicación del centro de trabajo:</Label>
          <Input
            placeholder=""
            value={formik.values.datosRelacionTrabajo.ubicacionInstitucion}
            invalid={formik.errors.datosRelacionTrabajo?.ubicacionInstitucion && true}
            onChange={(e) => { formik.setFieldValue("datosRelacionTrabajo['ubicacionInstitucion']", e.target.value) }}
          />
          {formik.errors.datosRelacionTrabajo?.ubicacionInstitucion && (<FormFeedback>{formik.errors.datosRelacionTrabajo?.ubicacionInstitucion}</FormFeedback>)}
        </div>
        {/* descripcionPuestos */}
        <div className="col-12 mb-1 w-input">
          <Label className="form-label fw-bolder" > Describa puesto y labores que desempeña:</Label>
          <Input
            placeholder=""
            value={formik.values.datosRelacionTrabajo.descripcionPuestos}
            invalid={formik.errors.datosRelacionTrabajo?.descripcionPuestos && true}
            onChange={(e) => { formik.setFieldValue("datosRelacionTrabajo['descripcionPuestos']", e.target.value) }}
          />
          {formik.errors.datosRelacionTrabajo?.descripcionPuestos && (<FormFeedback>{formik.errors.datosRelacionTrabajo?.descripcionPuestos}</FormFeedback>)}
        </div>
        
        {/* requiereSupervicion  */}
        <div className="col-12 d-flex flex-wrap  w-input" >
          <div className=" ww-auto mmr-1"><Label className='form-label fw-bolder my-auto' for={`input-requiereSupervicion `} >¿El puesto que desempeña implica labores de vigilancia o supervisión de otros médicos u otro personal médico?:</Label></div>
          <div className="ww-auto ">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`input-requiereSupervicion `} 
                checked={formik.values.datosEspecialidades.requiereSupervicion}
                id={`input-requiereSupervicion `}
                onChange={(e) => { formik.setFieldValue(`datosGenerales[requiereSupervicion ]`, e.target.checked) }}
              />
              <Label className='form-check-label' for={`input-requiereSupervicion `}>
                <span className='switch-icon-left'> <Check size={14} /> </span>
                <span className='switch-icon-right'> <X size={14} /> </span>
              </Label>
            </div>
          </div>
        </div>
      </div>
      {/* Sección de datosAparatos x */}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12 mb-2">Aparatos de Rayos X u otros aparatos</h3>
        {/* datosRayox */}
        <div className="col-12 w-input">
          <Label className="form-label fw-bolder" >Marque el(los) tipo(s) de aparato(s) que posee o utiliza:</Label>
          {rayos.length > 0 && (
              <div className="col-12 d-flex flex-wrap">
                {rayos.map((_item, index) => (
                  // {formik.values.especialidades.length > 0 &&
                  //   formik.values.especialidades.map((_item, index) => (
                  <div key={ `input${index}`} className={ ` ${_item.classContoiner ? _item.classContoiner : (_item.detalles === null ? " col-12 col-md-6 "  : " col-12 ")} d-flex flex-wrap mb-1`}>
                    <div className={ ` col-12  d-flex flex-wrap `}>
                      <div className="ww-auto ">
                        <div className='form-switch '>
                            <Input 
                            type='switch' 
                            name={`input-${_item.field}`} 
                            id={`input-${_item.field}`}
                            checked={formik.values.datosAparatos.datosRayox[_item.field]}
                            onChange={(e) => { formik.setFieldValue(`datosAparatos.datosRayox["${_item.field}"]`, e.target.checked) }}
                            />
                            <Label className='form-check-label' for={`input-${_item.field}`}>
                            <span className='switch-icon-left'>
                                <Check size={14} />
                            </span>
                            <span className='switch-icon-right'>
                                <X size={14} />
                            </span>
                            </Label>
                        </div>
                      </div>
                      <div className=" ww-auto mmr-1">
                        <Label className='form-label fw-bolder my-auto' for={`input-${_item.field}`} >{_item.label}</Label>
                      </div>
                    </div>
                    { ((typeof _item.detalles == '' ? false : _item.detalles !=  null) && formik.values.datosAparatos.datosRayox[_item.field]) && (
                      <div className= {` col-12 justify-center w-input`}>
                        <Label className="form-label fw-bolder"  for={`input-${_item.fieldDetalles}`}>{_item.detalles} {_item.fieldDetalles}:</Label>
                        <Input
                          value={ formik.values.datosAparatos.datosRayox[_item.fieldDetalles] }
                          onChange={(e) => { formik.setFieldValue(`datosAparatos.datosRayox[${_item.fieldDetalles}]`, e.target.value) }}
                        />
                      </div>
                    )}
                    
                  </div>
                ))}
              </div>
          )}
        </div>
        {/* pacientesRadioactivasNaturales */}
        <div className="col-12 d-flex flex-wrap">
            <div key={ `input-pacientesRadioactivasNaturales`} className={ ` col-12 d-flex flex-wrap mb-1`}>
              <div className={ ` col-12  d-flex flex-wrap `}>
                <div className=" ww-auto mmr-1">
                  <Label className='form-label fw-bolder my-auto' for={`input-pacientesRadioactivasNaturales`} >¿Posee y aplica a pacientes Materias Radioactivas Naturales? (*)</Label>
                </div>
                <div className="ww-auto ">
                  <div className='form-switch '>
                      <Input 
                      type='switch' 
                      checked={formik.values.datosAparatos.pacientesRadioactivasNaturales}
                      name={`input-pacientesRadioactivasNaturales`} 
                      id={`input-pacientesRadioactivasNaturales`}
                      onChange={(e) => { formik.setFieldValue(`datosAparatos["pacientesRadioactivasNaturales"]`, e.target.checked) }}
                      />
                      <Label className='form-check-label' for={`input-pacientesRadioactivasNaturales`}>
                      <span className='switch-icon-left'>
                          <Check size={14} />
                      </span>
                      <span className='switch-icon-right'>
                          <X size={14} />
                      </span>
                      </Label>
                  </div>
                </div>
              </div>
              {  formik.values.datosAparatos['pacientesRadioactivasNaturales'] && (
                <div className= {` col-12 justify-center w-input`}>
                  <Label className="form-label fw-bolder"  for={`input-pacientesRadioactivasNaturalesDetalles`}>Especifica:</Label>
                  <Input
                    value={ formik.values.datosAparatos["pacientesRadioactivasNaturalesDetalles"] }
                    onChange={(e) => { formik.setFieldValue(`datosAparatos[pacientesRadioactivasNaturalesDetalles]`, e.target.value) }}
                  />
                </div>
              )}
              
            </div>
        </div>
        {/* pacientesRadioactivasArtificiales */}
        <div className="col-12 d-flex flex-wrap">
            <div key={ `input-pacientesRadioactivasArtificiales`} className={ ` col-12 d-flex flex-wrap mb-1`}>
              <div className={ ` col-12  d-flex flex-wrap `}>
                <div className=" ww-auto mmr-1">
                  <Label className='form-label fw-bolder my-auto' for={`input-pacientesRadioactivasArtificiales`} >¿Posee y aplica a pacientes Materias radioactivas Artificiales? (*)</Label>
                </div>
                <div className="ww-auto ">
                  <div className='form-switch '>
                      <Input 
                      type='switch' 
                      checked={formik.values.datosAparatos.pacientesRadioactivasArtificiales}
                      name={`input-pacientesRadioactivasArtificiales`} 
                      id={`input-pacientesRadioactivasArtificiales`}
                      onChange={(e) => { formik.setFieldValue(`datosAparatos["pacientesRadioactivasArtificiales"]`, e.target.checked) }}
                      />
                      <Label className='form-check-label' for={`input-pacientesRadioactivasArtificiales`}>
                      <span className='switch-icon-left'>
                          <Check size={14} />
                      </span>
                      <span className='switch-icon-right'>
                          <X size={14} />
                      </span>
                      </Label>
                  </div>
                </div>
              </div>
              {  formik.values.datosAparatos['pacientesRadioactivasArtificiales'] && (
                <div className= {` col-12 justify-center w-input`}>
                  <Label className="form-label fw-bolder"  for={`input-pacientesRadioactivasArtificialesDetalles`}>Especifica:</Label>
                  <Input
                    value={ formik.values.datosAparatos["pacientesRadioactivasArtificialesDetalles"] }
                    onChange={(e) => { formik.setFieldValue(`datosAparatos[pacientesRadioactivasArtificialesDetalles]`, e.target.value) }}
                  />
                </div>
              )}
              
            </div>
        </div>
        {/* pacientesRadioactivasOtros */}
        <div className="col-12 d-flex flex-wrap">
            <div key={ `input-pacientesRadioactivasOtros`} className={ ` col-12 d-flex flex-wrap mb-1`}>
              <div className={ ` col-12  d-flex flex-wrap `}>
                <div className=" ww-auto mmr-1">
                  <Label className='form-label fw-bolder my-auto' for={`input-pacientesRadioactivasOtros`} >¿Posee y aplica a pacientes otro tipo de Materias Radioactivas? (*)</Label>
                </div>
                <div className="ww-auto ">
                  <div className='form-switch '>
                      <Input 
                      type='switch' 
                      name={`input-pacientesRadioactivasOtros`} 
                      checked={formik.values.datosAparatos.pacientesRadioactivasOtros}
                      id={`input-pacientesRadioactivasOtros`}
                      onChange={(e) => { formik.setFieldValue(`datosAparatos["pacientesRadioactivasOtros"]`, e.target.checked) }}
                      />
                      <Label className='form-check-label' for={`input-pacientesRadioactivasOtros`}>
                      <span className='switch-icon-left'>
                          <Check size={14} />
                      </span>
                      <span className='switch-icon-right'>
                          <X size={14} />
                      </span>
                      </Label>
                  </div>
                </div>
              </div>
              {  formik.values.datosAparatos['pacientesRadioactivasOtros'] && (
                <div className= {` col-12 justify-center w-input`}>
                  <Label className="form-label fw-bolder"  for={`input-pacientesRadioactivasOtrosDetalles`}>Especifica:</Label>
                  <Input
                    value={ formik.values.datosAparatos["pacientesRadioactivasOtrosDetalles"] }
                    onChange={(e) => { formik.setFieldValue(`datosAparatos[pacientesRadioactivasOtrosDetalles]`, e.target.value) }}
                  />
                </div>
              )}
              
            </div>
        </div>
      </div>
      {/* Sección de Otros riesgos*/}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12 mb-2">Otros Riesgos</h3>
        {/* poseeFarmacias */}
        <div className="col-12 d-flex flex-wrap">
            <div key={ `input-poseeFarmacias`} className={ ` col-12 d-flex flex-wrap mb-1`}>
              <div className={ ` col-12  d-flex flex-wrap `}>
                <div className=" ww-auto mmr-1">
                  <Label className='form-label fw-bolder my-auto' for={`input-poseeFarmacias`} >¿Posee u opera farmacias?</Label>
                </div>
                <div className="ww-auto ">
                  <div className='form-switch '>
                      <Input 
                      type='switch' 
                      checked={formik.values.datosAparatos.poseeFarmacias}
                      name={`input-poseeFarmacias`} 
                      id={`input-poseeFarmacias`}
                      onChange={(e) => { formik.setFieldValue(`datosAparatos["poseeFarmacias"]`, e.target.checked) }}
                      />
                      <Label className='form-check-label' for={`input-poseeFarmacias`}>
                      <span className='switch-icon-left'>
                          <Check size={14} />
                      </span>
                      <span className='switch-icon-right'>
                          <X size={14} />
                      </span>
                      </Label>
                  </div>
                </div>
              </div>
              {  formik.values.datosAparatos['poseeFarmacias'] && (
                <div className="col-12 d-flex flex-wrap">
                  <div className= {`col-12 col-md-6 justify-center w-input`}>
                    <Label className="form-label fw-bolder"  for={`input-numeroFarmaceuticosTituladosFarmaceuticos`}>Número de farmacéuticos titulados empleados (farmaco-biólogos, químicos, etc.):</Label>
                    <Input
                      value={ formik.values.datosAparatos["numeroFarmaceuticosTituladosFarmaceuticos"] }
                      onChange={(e) => { formik.setFieldValue(`datosAparatos[numeroFarmaceuticosTituladosFarmaceuticos]`, e.target.value) }}
                    />
                  </div>
                  <div className= {`col-12 col-md-6 justify-center w-input`}>
                    <Label className="form-label fw-bolder"  for={`input-numeroFarmaceuticosNoTituladosFarmaceuticos`}>Número de empleados no titulados:</Label>
                    <Input
                      value={ formik.values.datosAparatos["numeroFarmaceuticosNoTituladosFarmaceuticos"] }
                      onChange={(e) => { formik.setFieldValue(`datosAparatos[numeroFarmaceuticosNoTituladosFarmaceuticos]`, e.target.value) }}
                    />
                  </div>
                </div>
              )}
              
            </div>
        </div>
        {/* poseeLaboratorios */}
        <div className="col-12 d-flex flex-wrap">
            <div key={ `input-poseeLaboratorios`} className={ ` col-12 d-flex flex-wrap mb-1`}>
              <div className={ ` col-12  d-flex flex-wrap `}>
                <div className=" ww-auto mmr-1">
                  <Label className='form-label fw-bolder my-auto' for={`input-poseeLaboratorios`} >¿Posee y aplica a pacientes Materias radioactivas Artificiales? (*)</Label>
                </div>
                <div className="ww-auto ">
                  <div className='form-switch '>
                      <Input 
                      type='switch' 
                      checked={formik.values.datosAparatos.poseeLaboratorios}
                      name={`input-poseeLaboratorios`} 
                      id={`input-poseeLaboratorios`}
                      onChange={(e) => { formik.setFieldValue(`datosAparatos["poseeLaboratorios"]`, e.target.checked) }}
                      />
                      <Label className='form-check-label' for={`input-poseeLaboratorios`}>
                      <span className='switch-icon-left'>
                          <Check size={14} />
                      </span>
                      <span className='switch-icon-right'>
                          <X size={14} />
                      </span>
                      </Label>
                  </div>
                </div>
              </div>
              {  formik.values.datosAparatos['poseeLaboratorios'] && (
                <div className="col-12 d-flex flex-wrap">
                  <div className= {`col-12 col-md-6 justify-center w-input`}>
                    <Label className="form-label fw-bolder"  for={`input-numeroFarmaceuticosTituladosLaboratorios`}>Número de farmacéuticos titulados empleados (farmaco-biólogos, químicos, etc.):</Label>
                    <Input
                      value={ formik.values.datosAparatos["numeroFarmaceuticosTituladosLaboratorios"] }
                      onChange={(e) => { formik.setFieldValue(`datosAparatos[numeroFarmaceuticosTituladosLaboratorios]`, e.target.value) }}
                    />
                  </div>
                  <div className= {`col-12 col-md-6 justify-center w-input`}>
                    <Label className="form-label fw-bolder"  for={`input-numeroFarmaceuticosNoTituladosLaboratorios`}>Número de empleados no titulados:</Label>
                    <Input
                      value={ formik.values.datosAparatos["numeroFarmaceuticosNoTituladosLaboratorios"] }
                      onChange={(e) => { formik.setFieldValue(`datosAparatos[numeroFarmaceuticosNoTituladosLaboratorios]`, e.target.value) }}
                    />
                  </div>
                </div>
              )}
              
            </div>
        </div>
      </div>
      {/* Sección de coberturas*/}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12 mb-2">Coberturas Solicitadas</h3>
        {/* coberturas */}
        <div className="col-12 w-input">
          <Label className="form-label fw-bolder" >Marque las coberturas que desea contratar:</Label>
          {coberturas.length > 0 && (
              <div className="col-12 d-flex flex-wrap">
                {coberturas.map((_item, index) => (
                  // {formik.values.especialidades.length > 0 &&
                  //   formik.values.especialidades.map((_item, index) => (
                  <div key={ `input${index}`} className={ ` ${_item.classContoiner ? _item.classContoiner : (_item.detalles ? (_item.detalles === null ? " col-12 col-md-6 "  : " col-12 ") : ' col-12 col-md-6 ')} d-flex flex-wrap mb-1`}>
                    <div className={ ` ${_item.classContoiner ? _item.classContoiner : (_item.detalles === null ? " col-12 col-md-6 "  : " col-12 ")} d-flex flex-wrap `}>
                      <div className="ww-auto ">
                        <div className='form-switch '>
                            <Input 
                            type='switch' 
                            checked={formik.values.datosCobertura.coberturas[_item.field]}
                            name={`input-${_item.field}`} 
                            id={`input-${_item.field}`}
                            onChange={(e) => { formik.setFieldValue(`datosCobertura.coberturas["${_item.field}"]`, e.target.checked) }}
                            />
                            <Label className='form-check-label' for={`input-${_item.field}`}>
                            <span className='switch-icon-left'>
                                <Check size={14} />
                            </span>
                            <span className='switch-icon-right'>
                                <X size={14} />
                            </span>
                            </Label>
                        </div>
                      </div>
                      <div className=" ww-auto mmr-1">
                        <Label className='form-label fw-bolder my-auto' for={`input-${_item.field}`} >{_item.label}</Label>
                      </div>
                    </div>
                    {  ((typeof _item.detalles == '' ? false : _item.detalles !=  null) && formik.values.datosCobertura.coberturas[_item.field]) && (
                      <div className= {` ${(_item.detalles ? (_item.detalles === null ? " col-12 col-md-6 "  : " col-12 ") : ' col-12 col-md-6 ')} justify-center w-input`}>
                        <Label className="form-label fw-bolder"  for={`input-${_item.fieldDetalles}`}>{_item.detalles} {_item.fieldDetalles}:</Label>
                        <Input
                          value={ formik.values.datosCobertura.coberturas[_item.fieldDetalles] }
                          onChange={(e) => { formik.setFieldValue(`datosCobertura.coberturas[${_item.fieldDetalles}]`, e.target.value) }}
                        />
                      </div>
                    )}
                    
                  </div>
                ))}
              </div>
          )}
        </div>
        {/* inmuebles */}
        <div className="col-12 w-input">
          <div className="d-flex flex-nowrap col-12 w-input">
            <Label className="ww-150A form-label fw-bolder" >Indique si el(los) inmueble(s) es(son) propio(s) o arrendado(s), su ubicación y uso:</Label>
            <div className="ww-150 mx-auto mb-1">
                <Button
                  className=""
                  color="success"
                  disabled={formik.values.datosCobertura.inmuebles.length >= 4 }
                  size="sm"
                  onClick={ () => { addInmuebles() } }
                >Agregar inmueble  </Button>
            </div>
          </div>
          {formik.values.datosCobertura.inmuebles.length > 0 && (
              <div className="col-12 d-flex flex-wrap">
                {formik.values.datosCobertura.inmuebles.map((_item, index) => (
              <div className="col-12 w-input d-flex flex-wrap mb-2">
                <div className="col-12 d-flex align-middle ">
                  <Label className=" ww-100A form-label my-auto  fw-bolder" for="tipo">Inmueble # {index + 1} : </Label>
                  <Button color='danger' className='ww-100 cursor-pointer fw-bolder text-nowrap px-1' size="sm" onClick={ () => { deleteItem(_item, 1) }} outline>
                    <Trash size={14} className='me-50' />
                    <span className="align-middle fw-bolder">Eliminar</span>
                  </Button>
                  {/* <X size={18} className='cursor-pointer' onClick={ () => { deleteItem(_item) }} /> */}
                </div>
                  {/* Tipo */}
                  <div className="col-12 col-md-6 mb-1 w-input">
                    <Label className="form-label fw-bolder" >Tipo:</Label>
                    <Input
                      placeholder=""
                      value={formik.values.datosCobertura.inmuebles[index].tipo}
                      invalid={formik.errors.datosCobertura?.inmuebles[index].tipo && true}
                      onChange={(e) => { formik.setFieldValue(`datosCobertura['inmuebles'][${index}].tipo`, e.target.value) }}
                    />
                  </div>
                  {/* Uso */}
                  <div className="col-12 col-md-6 mb-1 w-input">
                    <Label className="form-label fw-bolder" >Uso:</Label>
                    <Input
                      placeholder=""
                      value={formik.values.datosCobertura.inmuebles[index].uso}
                      invalid={formik.errors.datosCobertura?.inmuebles[index].uso && true}
                      onChange={(e) => { formik.setFieldValue(`datosCobertura['inmuebles'][${index}].uso`, e.target.value) }}
                    />
                  </div>
                  {/* Direccion */}
                  <div className="col-12 mb-1 w-input">
                    <Label className="form-label fw-bolder" >Ubicación:</Label>
                    <Input
                      placeholder=""
                      value={formik.values.datosCobertura.inmuebles[index].ubicacion}
                      invalid={formik.errors.datosCobertura?.inmuebles[index].ubicacion && true}
                      onChange={(e) => { formik.setFieldValue(`datosCobertura['inmuebles'][${index}].ubicacion`, e.target.value) }}
                    />
                  </div>
                  
              </div>
                ))}
              </div>
          )}
        </div>
        {/* experiencias */}
        <div className="col-12 w-input">
          <div className="d-flex flex-nowrap col-12 w-input">
            <Label className="ww-180A form-label fw-bolder" >Indique experiencia de siniestros o reclamaciones durante los últimos 5 años (incluyendo en el extranjero):</Label>
            <div className="ww-180 mx-auto mb-1 text-end">
                <Button
                  className=" mr-auto "
                  disabled={formik.values.datosCobertura.experiencias.length >= 3 }
                  color="success"
                  size="sm"
                  onClick={ () => { addExperiencias() } }
                >Agregar experiencia </Button>
            </div>
          </div>
          {formik.values.datosCobertura.experiencias.length > 0 && (
              <div className="col-12 d-flex flex-wrap">
                {formik.values.datosCobertura.experiencias.map((_item, index) => (
              <div className="col-12 w-input d-flex flex-wrap mb-2">
                <div className="col-12 d-flex align-middle ">
                  <Label className=" ww-100A form-label my-auto  fw-bolder" for="tipo">Experiencias # {index + 1} : </Label>
                  <Button color='danger' className='ww-100 cursor-pointer fw-bolder text-nowrap px-1' size="sm" onClick={ () => { deleteItem(_item, 2) }} outline>
                    <Trash size={14} className='me-50' />
                    <span className="align-middle fw-bolder">Eliminar</span>
                  </Button>
                  {/* <X size={18} className='cursor-pointer' onClick={ () => { deleteItem(_item) }} /> */}
                </div>
                  {/* Tipo */}
                  <div className="col-12 col-md-6 mb-1 w-input">
                    <Label className="form-label fw-bolder" >Daño ocasionado:</Label>
                    <Input
                      placeholder=""
                      value={formik.values.datosCobertura.experiencias[index].danio}
                      invalid={formik.errors.datosCobertura?.experiencias[index].danio && true}
                      onChange={(e) => { formik.setFieldValue(`datosCobertura['experiencias'][${index}].danio`, e.target.value) }}
                    />
                  </div>
                  {/* Uso */}
                  <div className="col-12 col-md-6 mb-1 w-input">
                    <Label className="form-label fw-bolder" > Monto: </Label>
                    <Input
                      placeholder=""
                      value={formik.values.datosCobertura.experiencias[index].monto}
                      invalid={formik.errors.datosCobertura?.experiencias[index].monto && true}
                      onChange={(e) => { formik.setFieldValue(`datosCobertura['experiencias'][${index}].monto`, e.target.value) }}
                    />
                  </div>
                  {/* Direccion */}
                  <div className="col-12 mb-1 w-input">
                    <Label className="form-label fw-bolder" >Motivo:</Label>
                    <Input
                      placeholder=""
                      value={formik.values.datosCobertura.experiencias[index].motivo}
                      invalid={formik.errors.datosCobertura?.experiencias[index].motivo && true}
                      onChange={(e) => { formik.setFieldValue(`datosCobertura['experiencias'][${index}].motivo`, e.target.value) }}
                    />
                  </div>
                  
              </div>
                ))}
              </div>
          )}
        </div>
      </div>
      {/* Btn de guardar */}
      <div className=" mb-1 d-flex justify-content-end">
        <Button className="m-1" color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default ResponsabilidadCivilForm
